import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { PAGES } from '../../constants';
import { getDateTime } from '../../utils/common';

const LeftHeadersTable = ({ onExportToExcel, oddsDetails, timezone }) => {
  const params = useParams();

  const formattedOddsDetails = oddsDetails.map(detail => {
    const [date, time] = getDateTime(detail.dateTime, timezone).split(' ');
    const [hour, minute] = time.split(':');
    return {
      time: `${date} ${hour}:${minute}`,
      minute: detail.roundMinute,
      totalScore: detail.totalScore
    };
  });

  return <div className="odds__left">
    <table className="odds__table">
      <thead>
        <tr className="tr--first">
          <th colSpan={3} className="text-left">
            <button
              id="exportToExcel_OddsHistory2"
              type="button"
              className="btn btn-primary"
              onClick={onExportToExcel}
            >
              Export to Excel
            </button>
            <Link
              to={`${PAGES.ROUND_SPECIALS_ODDS_HISTORY_STEP_1}/${params.id}`}
              className="btn btn-secondary m-l-10"
            >
              Change Selected Markets
            </Link>
          </th>
        </tr>
        <tr className="tr--primary">
          <th>Date</th>
          <th className="odds__table-time">
            Round
            <br />
            Minutes
          </th>
          <th className="odds__table-score">Total Score</th>
        </tr>
      </thead>
      <tbody className="bgwhite">
        {formattedOddsDetails.map((detail) => (
          <tr key={detail.minute}>
            <td>{detail.time}</td>
            <td>{`${detail.minute}'`}</td>
            <td>{detail.totalScore}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>;
};

export default LeftHeadersTable;